<template>
    <div v-if="isVisible" class="popup-container">
        <div class="card white popup">
            <h2>{{ title }}</h2>
            <p v-html="message"></p>
            <div class="popup-actions">
                <button class="button fill orange" @click="confirmAction">{{ confirmButtonText }}</button>
                <button class="button outline orange" @click="cancelAction">{{ cancelButtonText }}</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isVisible: Boolean,
        title: String,
        message: String,
        confirmButtonText: {
            type: String,
            default: "Confirmer",
        },
        cancelButtonText: {
            type: String,
            default: "Annuler",
        },
    },
    methods: {
        confirmAction() {
            this.$emit("confirm");
        },
        cancelAction() {
            this.$emit("cancel");
        },
    },
};
</script>